import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApplicationService } from '@app/shared/application/application.service';
import { EhcService } from './ehc.service';
import { AppComponentBase } from '@shared/common/app-component-base';

@Injectable()
export class EhcGuard implements CanActivate, CanDeactivate<AppComponentBase> {

    constructor(
        private ehcService: EhcService,
        private applicationService: ApplicationService,
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
       return this.ehcService.getEhc(this.applicationService.caseId).pipe(map(() => true));
    }

    canDeactivate(component: AppComponentBase): boolean | Observable<boolean> {
        this.ehcService.closeEhc();
        return true;
    }
}
